import SlotGamePopupGameCard from '../SlotGamePopupGameCard'

const GamePopup = ({ popupClose, gameId, link }) => {
    return (
        <section className='slot-game-popup fixed left-0 xl:left-[250px] right-0 bottom-0 top-0 bg-[#000c] z-[9998]'>
            <div className='slot-game-popup-container xl:max-w-[1200px] w-[90%] lg:w-full fixed lg:absolute left-1/2 lg:left-0 xl:left-1/2 top-[80px] bottom-[80px] overflow-y-auto ml-[-45%] lg:ml-0 xl:ml-[-600px] bg-obsidian border-[10px] border-slate '>
                <button type="button" className='fixed top-auto lg:top-10 text-[40px] leading-[30px]' onClick={popupClose}>
                    <i className='icofont icofont-close'></i>
                </button>

                {/* Embedded game */}
                <iframe
                    src={link}
                    title="Slot Game"
                    className="w-full h-full"
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
            </div>
        </section>
    )
}

export default GamePopup